<template>
  <div id="content" v-show="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction">
    </popup>
    <div class="inner">
      <p class="paging">
        <router-link :to="{ name: moduleName, params: { tab: tabName} }" class="btn btn_back" v-translate>Seznam</router-link>
      </p>
      <p class="buttons">
        <a v-if="$_loggedUser_action_allowed('messages', 'create')"
           class="btn btn_action btn_grey btn_notification"
           :title="'Odeslat oznámení' | translate"
           @click.prevent.stop="newMessage" v-translate>Odeslat oznámení</a>
        <a v-if="!entity.active && $_updateActionAllowed"
           class="btn btn_action btn_grey btn_enable"
           :title="'Aktivovat' | translate"
           @click.prevent.stop="updateEntityActive('active', true)"
           v-translate>Aktivovat</a>
        <a v-if="entity.active && $_updateActionAllowed"
           class="btn btn_action btn_grey btn_disable"
           :title="'Deaktivovat' | translate"
           @click.prevent.stop="updateEntityActive('active', false)"
           v-translate>Deaktivovat</a>
        <a v-if="$_updateActionAllowed"
           class="btn btn_action btn_grey btn_refresh"
           :title="'Smazat cache všech zařízení odběratele' | translate"
           @click.prevent.stop="deleteSubscriberDevicesCache"
           v-translate>Smazat cache všech zařízení odběratele</a>
        <a v-if="$_deleteActionAllowed"
           class="btn btn_action btn_delete"
           :title="'Smazat' | translate"
           @click.prevent.stop="deleteEntity"
           v-translate>Smazat</a>
      </p>
      <h1 v-if="hasName">{{ entity.surname }} {{ entity.firstname }}
        <span>{{ companyTown }}</span>
      </h1>
      </div>
      <div class="responsiveTabs r-tabs">
        <ul class="tabs">
          <li :class="getActiveTabClass('settings')">
            <a
                @click.prevent.stop="activateTab('settings')"
                v-translate>Vlastnosti
            </a>
          </li>
          <li :class="getActiveTabClass('biller')" v-if="$_loggedUser_action_allowed('billers')">
            <a
                @click.prevent.stop="activateTab('biller')"
                v-translate>Plátce
            </a>
          </li>
          <li :class="getActiveTabClass('servicesList')" v-if="$_loggedUser_action_allowed('services')">
            <a
                @click.prevent.stop="activateTab('servicesList')"
                v-translate>Služby
            </a>
          </li>
          <li :class="getActiveTabClass('devices')" v-if="$_loggedUser_action_allowed('devices')">
            <a
                @click.prevent.stop="activateTab('devices')"
                v-translate>Zařízení
            </a>
          </li>
          <li :class="getActiveTabClass('profiles')">
            <a
                @click.prevent.stop="activateTab('profiles')"
                v-translate>Profily
            </a>
          </li>
          <li :class="getActiveTabClass('channelGroups')" v-if="$_loggedUser_action_allowed('channelGroups')">
              <a
                  @click.prevent.stop="activateTab('channelGroups')"
                  v-translate>Skupiny stanic
              </a>
          </li>
          <li :class="getActiveTabClass('pvrs')">
            <a
                @click.prevent.stop="activateTab('pvrs')"
                v-translate>Nahrávky
            </a>
          </li>
          <li :class="getActiveTabClass('favoriteShows')">
            <a
                @click.prevent.stop="activateTab('favoriteShows')"
                v-translate>Oblíbené pořady
            </a>
          </li>
          <li :class="getActiveTabClass('periodicPvrs')">
            <a
                @click.prevent.stop="activateTab('periodicPvrs')"
                v-translate>Pravidelné nahrávky
            </a>
          </li>
          <li :class="getActiveTabClass('messages')" v-if="$_loggedUser_action_allowed('messages')">
              <a
                  @click.prevent.stop="activateTab('messages')"
                  v-translate>Oznámení
              </a>
          </li>
          <li :class="getActiveTabClass('advertisingBanners')" v-if="$_loggedUser_action_allowed('advertisingBanners')">
            <a
                @click.prevent.stop="activateTab('advertisingBanners')"
                v-translate>Marketingová oznámení
            </a>
          </li>
          <li :class="getActiveTabClass('dashboard')">
            <a
                @click.prevent.stop="activateTab('dashboard')"
                v-translate>Dashboard
            </a>
          </li>
          <li :class="getActiveTabClass('restrictedChannels')">
            <a
                @click.prevent.stop="activateTab('restrictedChannels')"
                v-translate>Restrikce kanálů
            </a>
          </li>
          <li :class="getActiveTabClass('purchasedVodVideos')">
            <a
                @click.prevent.stop="activateTab('purchasedVodVideos')"
                v-translate>Zakoupená TVOD videa
            </a>
          </li>
        </ul>
        <div class="tabs_content" v-show="isActiveTab('settings')">
          <section v-show="$_readActionAllowedAll">
            <div class="left">
              <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <operator-select
                    v-model="entity.id_operator"
                    :options="operatorOptions"
                    :disabled="true"
                >
                </operator-select>
              </div>
            </div>
          </section>
          <section>
          <div class="left">
            <detail-entity-info
                :entity="entity"
            >
              <p>
                <translate class="translate">Počet zařízení</translate>: {{ deviceCount }}
              </p>
            </detail-entity-info>
          </div>
          <basic-info
              :entity="entity"
              ref="basicinforef"
              :is-editable="$_updateActionAllowed"
          />
          </section>
          <contact
              :subscriber="entity"
              ref="contactref"
              :is-editable="$_updateActionAllowed"
          />
          <settings
              :subscriber="entity"
              :subjectTypeOptions="subjectTypes"
              :subscriberTypeOptions="subscriberTypes"
              :is-editable="$_updateActionAllowed"
              :password-editable="$_updateActionAllowed && hasEmail"
              ref="settingsref"
              @set-password="setNewPassword"
              @resetPassword="resetSubscriberPassword"
          />
          <section class="buttons">
            <p>
              <router-link
                  :to="{ name: moduleName }"
                  class="btn btn_back btn_seznam"
                  v-translate>Seznam
              </router-link>
              <input
                  v-if="$_updateActionAllowed"
                  type="submit"
                  :value="'Uložit vlastnosti' | translate"
                  :class="['btn', { btn_inactive: !formIsValid }]"
                  @click.prevent.stop="submitForm()"
              />
            </p>
          </section>
        </div>
        <div class="tabs_content" v-show="isActiveTab('biller') && $_loggedUser_action_allowed('billers')">
          <payer :title1="'Plátce' | translate"
                 :title2="'Nový plátce' | translate" ref="payerref"
                 :payer-open="newBillerOpen"
                 :new-biller="newBiller"
                 :biller-id="entity.id_biller"
                 :payer-options="billers"
                 :operator-options="operatorOptions"
                 :subjectTypeOptions="subjectTypes"
                 :selected-biller="selectedBiller"
                 @biller-id-change="billerIdChange"
                 @new-biller-open="setBillerOpen"
                 :is-editable="$_updateActionAllowed"
          ></payer>
          <section class="buttons">
            <p>
              <router-link
                  :to="{ name: moduleName }"
                  class="btn btn_back btn_seznam"
                  v-translate>Seznam
              </router-link>
              <input
                  type="submit"
                  :value="'Uložit plátce' | translate"
                  :class="['btn', { btn_inactive: !formIsValid }]"
                  @click.prevent.stop="submitForm()"
                  v-if="$_updateActionAllowed"
              />
            </p>
          </section>
        </div>
        <div class="tabs_content" v-if="this.entity.id && isActiveTab('servicesList') && $_loggedUser_action_allowed('services')">
          <services-list :services="assignedSubscriberServices"
                    :available-services="availableServices"
                    :all-channels="allChannels"
                    :all-device-groups="allDeviceGroups"
                    :device-group-channels-restriction="deviceGroupChannelsRestriction"
                    :summed="subscriberSummed"
                    :service-intervals-options="serviceIntervalsOptions"
                    :is-editable="$_updateActionAllowed"
                    @interval-changed="getSubscriberFinalServiceByInterval"
                    @add="addSubscriberServices"
                    @delete="deleteSubscriberService"
                    @save-subscriber-service-validity="updateSubscriberServices"
                    @remove-subscriber-service-validity="updateSubscriberServices"
                    @available-services-sorting-change="getSubscriberServices"
          ></services-list>
        </div>
        <div class="tabs_content" v-if="this.entity.id && isActiveTab('devices') && $_loggedUser_action_allowed('devices')">
          <devices :id-subscriber="entity.id"
                   :devices="entity.devices"
                   :device-profiles="deviceProfiles"
                   :new-device="newDevice"
                   :new-device-open="newDeviceOpen"
                   :pairing-codes="entity.pairing_codes"
                   :new-pairing-code="newPairingCode"
                   :new-pairing-code-open="newPairingCodeOpen"
                   :is-allowed-to-add-device-or-pairing-code="entity.is_allowed_to_add_device_or_pairing_code"
                   :is-editable="$_loggedUser_operator_item_update_action_allowed(entity.id_operator, 'devices')"
                   :device-service="deviceService"
                   :deviceLogViewerUrl="entity.device_log_viewer_url"
                   @new-device-open="setNewDeviceOpen"
                   @new-pairing-code-open="setNewPairingCodeOpen"
                   @add-new-device="addDevice"
                   @update-device="updateDevice"
                   @delete-device="deleteDevice"
                   @add-new-pairing-code="addPairingCode"
                   @delete-pairing-code="deletePairingCode"
                   @devices-refresh="refreshDevicesAndPairingCodes(true)"
                   ref="devicesref"
          />
        </div>
        <div class="tabs_content" v-if="isActiveTab('profiles')">
          <Profiles
              :id-subscriber="entity.id"
              :profiles="profiles"
              :is-editable="$_updateActionAllowed"
              @deleteProfile="onDeleteProfile" />
        </div>
        <div class="tabs_content" v-if="this.entity.id && isActiveTab('channelGroups') && $_loggedUser_action_allowed('channelGroups')">
            <SubscriberChannelGrups
                :subscriber="this.entity"
                :is-editable="$_updateActionAllowed"
                @delete-subscriber="deleteEntity(false);"
                @reload-entity="getEntity()"
            />
        </div>
        <div class="tabs_content"  v-if="isActiveTab('pvrs')">
            <Pvrs
                :subscriber="entity"
                :subscriberSummed="subscriberSummed"
                :is-editable="$_updateActionAllowed"
                @deletePvr="onDeletePvr" />
        </div>
        <div class="tabs_content"  v-if="isActiveTab('favoriteShows')">
          <FavoriteShows
              :favoriteShows="favoriteShows"
              :is-editable="$_updateActionAllowed"
              @deleteFavoriteShow="onDeleteFavoriteShow" />
        </div>
        <div class="tabs_content"  v-if="isActiveTab('periodicPvrs')">
          <PeriodicPvrs
              :periodicPvrs="periodicPvrs"
              :is-editable="$_updateActionAllowed"
              @deletePeriodicPvr="onDeletePeriodicPvr" />
        </div>
        <div class="tabs_content"  v-if="isActiveTab('messages') && $_loggedUser_action_allowed('messages')">
            <Messages
                :subscriber="entity"
                :messages="messages"
                :is-editable="$_updateActionAllowed"
                @deleteMessage="onDeleteMessage" />
        </div>
        <div class="tabs_content" v-if="isActiveTab('advertisingBanners') && $_loggedUser_action_allowed('advertisingBanners')">
          <AdvertisingBanners
              :subscriber="entity"
              :advertising-banners="advertisingBanners"
              :is-editable="$_updateActionAllowed"
              @deleteAdvertisingBanner="onDeleteAdvertisingBanner" />
        </div>
        <div class="tabs_content"  v-show="isActiveTab('dashboard')">
          <Dashboard :subscriber="entity" />
        </div>
        <div class="tabs_content"  v-show="isActiveTab('restrictedChannels')">
          <RestrictedChannels :subscriber="entity" :allChannels="allChannels"/>
        </div>
        <div class="tabs_content"  v-show="isActiveTab('purchasedVodVideos')">
          <PurchasedVodVideos :purchased-vod-videos="purchasedVodVideos" />
        </div>
      </div>
  </div>
</template>

<script>
import BasicInfo from "@/components/views/subscribers/settings/BasicInfo"
import Contact from "@/components/views/subscribers/settings/Contact"
import Settings from "@/components/views/subscribers/settings/Settings"
import Payer from "@/components/views/subscribers/payer/Payer"
import Devices from "@/components/views/subscribers/devices/Devices"

import detailActions from "@/components/mixins/detail-actions"
import subscribers from "@/components/views/subscribers/mixins/subscribers"
import subscriberData from "@/components/mixins/subscriber-data"
import selectOperator from "@/components/mixins/select-operator-business-model"
import Pvrs from "./pvrs/Pvrs";
import FavoriteShows from "./favoriteShows/FavoriteShows";
import Messages from "./messages/Messages";
import AdvertisingBanners from "./advertisingBanners/AdvertisingBanners";
import SubscriberChannelGrups from "./channelGroups/ChannelGroups";
import PeriodicPvrs from "./periodicPvrs/PeriodicPvrs";
import Dashboard from "./dashboard/Dashboard";
import Profiles from "./profiles/Profiles.vue";
import RestrictedChannels from "./restrictedChannels/RestrictedChannels.vue";
import ServicesList from "./servicesList/ServicesList.vue";
import PurchasedVodVideos from "./purchasedVodVideos/PurchasedVodVideos.vue";

export default {
  name: "SubscriberDetail",
  components: {
    Messages,
    AdvertisingBanners,
    Pvrs,
    SubscriberChannelGrups,
    BasicInfo,
    Contact,
    Settings,
    Payer,
    ServicesList,
    Devices,
    FavoriteShows,
    PeriodicPvrs,
    Dashboard,
    Profiles,
    RestrictedChannels,
    PurchasedVodVideos
  },
  mixins: [detailActions, subscriberData, subscribers, selectOperator],
  data: function () {
    return {
      billers: [],
      messages: [],
      advertisingBanners: [],
      billerIdChanged: false,
      changedBillerId: null,
      billerOpen: false,
      newDeviceOpen: false,
      newPairingCodeOpen: false,
      selectedBiller: {address: {}},
      allChannels: [],
      allDeviceGroups: [],
      deviceProfiles: [],
      deviceGroupChannelsRestriction: {},
      subscriberSummed: {},
      serviceIntervalsOptions: [],
      purchasedVodVideos: [],
      favoriteShows: null,
      periodicPvrs: null,
      profiles: null,
      oldEmail: null,
    }
  },
 created(
      SubscriberService,
      DeviceService,
      PairingCodeService,
      BillerService,
      OperatorService,
      PvrService,
      MessageService,
      FavoriteShowService,
      PeriodicPvrService,
      SubscriberProfileService,
      AdvertisingBannerRecipientService
  ) {
    this.entityService = SubscriberService
    this.deviceService = DeviceService
    this.pairingCodeService = PairingCodeService
    this.billerService = BillerService
    this.operatorService = OperatorService
    this.pvrService = PvrService
    this.periodicPvrService = PeriodicPvrService
    this.messageService = MessageService
    this.favoriteShowService = FavoriteShowService
    this.subscriberProfileService = SubscriberProfileService
    this.advertisingBannerRecipientService = AdvertisingBannerRecipientService
    this.getOperators()
    this.createdInit()
        .then(() => {
          this.oldEmail = this.entity.email;
          this.newBiller.id_operator = this.entity.id_operator
          this.getFormFilterData(this.entity.id_operator)

            if (this.$route.name==="subscriberDetailDevices") {
                this.activateTab('devices');
            } else if (this.$route.name==="subscriberDetailChannelGroups") {
                this.activateTab('channelGroups');
            }
        })
   if('tab' in this.$route.params){
     this.activateTab(this.$route.params.tab);
   }
  },
  beforeDestroy() {
    this.activateTab('settings')
  },
  computed: {
    entity() {
      return entity
    },
    isOperatorActive() {
      return Boolean(this.entity.operator_active)
    },
    assignedSubscriberServices() {
      let assigned = {
        ...this._.filter(this.services, function (service) {
          return service.checked
        })
      }

      return this._.sortBy(assigned, function (service) {
        return service.name
      })
    },
    availableServices() {
      return this._.filter(this.services, function (service) {
        return !service.checked
      })
    },
    newBillerOpen() {
      return this.billerOpen
    },
    deviceCount() {
      return this._.keys(this.entity.devices).length
    },
    hasEmail(){
      if(this.oldEmail){
        return this.oldEmail.length > 0;
      }else{
        return false;
      }
    }
  },
  methods: {
    submitForm(redirect = false) {
      if (this.isActiveTab('settings')) {
        this.updateEntity(this.entity, redirect)
            .then(()=>{
              this.oldEmail = this.entity.email;
            })
      }
      if (this.isActiveTab('biller')) {
        if (this.newBillerOpen) {
          this.addBiller(redirect)
        } else {
          this.updateSubscriberBiller(redirect)
        }
      }
    },

    redirect() {
      this.$router.push({name: 'subscribers'})
    },
    setBillerOpen(open) {
      this.billerOpen = open
    },
    billerIdChange(billerId) {
      this.changedBillerId = billerId
      this.billerIdChanged = (Number(billerId) !== Number(this.entity.id_biller))
      if (this.changedBillerId) {
        this.getBiller(this.changedBillerId)
      }
    },
    setNewDeviceOpen(open) {
      this.newDeviceOpen = open
    },
    setNewPairingCodeOpen(open) {
      this.newPairingCodeOpen = open
    },
    executePopupAction(value) {
      if (value === true) {
        if (this.getPopupAction === 'delete') {
          this.deleteEntity(false)
        }
        if (this.getPopupAction === 'delete-service') {
          this.deleteSubscriberService(this.getPopupId, false)
        }
        if (this.getPopupAction === 'delete-device' || this.getPopupAction === 'delete-device-multi') {
          this.deleteDevice(this.getPopupId, false)
        }
        if (this.getPopupAction === 'delete-pairing-code') {
          this.deletePairingCode(this.getPopupId, false)
        }
        if (this.getPopupAction === 'deleteMessage') {
            this.onDeleteMessage(this.getPopupId, false);
        }
        if (this.getPopupAction === 'deleteAdvertisingBanner') {
          this.onDeleteAdvertisingBanner(this.getPopupId, false);
        }
        if (this.getPopupAction === 'deletePvr') {
            this.onDeletePvr(this.getPopupId, false);
        }
        if (this.getPopupAction === 'deleteProfile') {
          this.onDeleteProfile(this.getPopupId, false);
        }
        if (this.getPopupAction === 'deleteFavoriteShow') {
          this.onDeleteFavoriteShow(this.getPopupId, false);
        }
        if (this.getPopupAction === 'deletePeriodicPvr') {
          this.onDeletePeriodicPvr(this.getPopupId, false);
        }
      }
      this.hidePopup()
    },

    // SUBSCRIBER
    _afterGetEntityActions(data) {
      this.billers = data['billers']
      this.allChannels = data['all_channels']
      this.allDeviceGroups = data['all_device_groups']
      this.deviceProfiles = data['device_profiles']
      this.messages = data['messages']
      this.advertisingBanners = data['advertisingBanners']
      this.deviceGroupChannelsRestriction = data['device_group_channels_restriction']
      this.favoriteShows = data['favorite_shows']
      this.periodicPvrs = data['periodic_pvrs']
      this.profiles = data['profiles']
      this.purchasedVodVideos = data['purchased_vod_videos'];

      this.getSubscriberServices(this.getDefaultByModuleName('subscriberServices', 'sort'))
      this.getSubscriberFinalServiceByInterval()

      this.resetFields()
      this.newPassword = null
      this.$refs['settingsref'].resetPassword()

      // biller
      this.changedBillerId = this.entity.id_biller
      this.getBiller(this.entity.id_biller)
    },

    // BILLER
    getBiller(id) {
      if (!id) {
        return
      }
      this.billerService.getEntity(id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
          .then(data => {
            this.selectedBiller = data.biller
          })
          .catch(function (error) {
            this.setErrorMessage(error['error_message'])
          }.bind(this))
    },
    updateSubscriberBiller(redirect = false) {
      const billerId = this.billerIdChanged ? this.changedBillerId : this.entity.id_biller
      this.entityService.updateEntity(this.entity.id, {'id_biller': billerId})
          .then(() => {
            if (redirect === true) {
              this.redirect()
            } else {
              this.setSuccessMessage()
              this.getEntity()
            }
          })
          .catch(function (error) {
            this.setErrorMessage(error['error_message'])
          }.bind(this))
    },
    addBiller(redirect = false) {
      this.entityService.createBiller(
          this.entity.id,
          this.$refs['payerref'].filterFormParams({...this.newBiller})
      )
          .then(() => {
            if (redirect === true) {
              this.redirect()
            } else {
              this.setSuccessMessage()
              this.getFormFilterData(this.entity.id_operator)
              this.getEntity()
              this.resetNewBiller()
              this.setBillerOpen(false)
            }
          })
          .catch(function (error) {
            this.$refs['payerref'].processErrorMessage(error)
            this.setErrorMessage(error['error_message'])
          }.bind(this))
    },

    // SERVICES
    addSubscriberServices(ids) {
      this.callUpdateSubscriberServicesMethod(this.getAddSubscriberServicesParams(ids))
    },
    updateSubscriberServices(data) {
      this.callUpdateSubscriberServicesMethod(this.getUpdateSubscriberServicesParams(data))
    },
    deleteSubscriberService(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'delete-service')
      } else {
        this.callUpdateSubscriberServicesMethod(this.getDeleteSubscriberServicesParams(id))
      }
    },
    callUpdateSubscriberServicesMethod(params) {
      this.entityService.updateSubscriberServices(this.entity.id, params)
          .then(() => {
            this.setSuccessMessage()
            this.getEntity()
          })
          .catch(function (error) {
            this.setErrorMessage(this.processSubscriberServiceErrorMessage(error))
          }.bind(this))
    },
    getAddSubscriberServicesParams(ids) {
      let create = {}
      this._.assign(create, {'ids': ids})

      return {'create': create}
    },
    getUpdateSubscriberServicesParams(data) {
      let update = {}
      this._.assign(update, this.getSubscriberServicesParamsByAction(data, 'update'))
      return {'update': update}
    },
    getDeleteSubscriberServicesParams(id) {
      let remove = {}
      this._.assign(remove, this.getSubscriberServicesParamsByAction({'id': id}, 'delete'))
      return {'delete': remove}
    },
    getSubscriberServicesParamsByAction(data, action) {
      let params = {}
      let serviceId = data['id']
      if (action === 'update') {
        params[serviceId] = {
          'id': serviceId,
          'active_from': this.$_date_toMysqlFormatFromString(data['active_from']),
          'active_to': this.$_date_toMysqlFormatFromString(data['active_to']),
        }
      } else {
        params[serviceId] = {'id': serviceId}
      }
      return params
    },
    getSubscriberServices(params) {
      this.entityService.getSubscriberServices(this.entity['id'], {sort: params})
          .then(response => {
            this.services = response['services']
          })
    },
    getSubscriberFinalServiceByInterval(interval = null) {
      let params = null
      if (interval !== null) {
        let splitValues = this._.split(interval, '-')
        // always send "from" except when "from" is null/zero/unlimited, in such case send "to"
        let timestamp = Number(splitValues[0]) === 0 ? Number(splitValues[1]) : Number(splitValues[0])
        params = {'timestamp': timestamp}
      }

      this.setLoadingMessage()
      this.entityService.getSubscriberServiceIntervals(this.entity.id, params)
          .then(data => {
            this.emptyMessage()
            this.subscriberSummed = data['summed']
            this.serviceIntervalsOptions = data['service_intervals_options'].map(item => {
              let newText = item.text;

              if (newText.includes("neomezeně")) {
                newText = newText.replace(/neomezeně/g, this.$gettext("neomezeně"));
              }

              return {
                ...item,
                text: newText
              };
            });
          })
          .catch((error) => {
            this.setErrorMessage(error['error_message'])
          })
    },
    deleteSubscriberDevicesCache() {
      this.entityService.deleteSubscriberDevicesCache(this.entity.id)
          .then(() => {
            this.setSuccessMessage()
          })
          .catch((error) => {
            this.setErrorMessage(error['error_message'])
          })
    },

    resetSubscriberPassword(params){
      this.entityService.resetSubscriberPassword(this.entity.id, params)
        .then(data=>{
          this.setSuccessMessage(this.$gettext("Nové heslo bylo úspěšně odesláno na e-mail ")+this.entity.email);
        })
      .catch(error => {
        error['validation_errors'].forEach(error=>{
          let errorMessage;

          if(error === "Receiver email address is not defined."){
            errorMessage = this.$gettext('Odběratel nemá definovanou adresu, na kterou by mohl být zaslán email s heslem.')
          }else if(error === "Default sender email address is not defined."){
            errorMessage = this.$gettext('Není definována kontaktní adresa odesilatele.')
          }else if(this._.includes(error, 'No email template for message type')){
            errorMessage = this.$gettext('Není definována šablona emailu pro reset hesla.')
          }
          else{
            errorMessage = error;
          }
          this.setErrorMessage(errorMessage);
        });
        })
    },

    // DEVICES AND PAIRING CODES
    refreshDevicesAndPairingCodes(pureRefresh = false) {
      pureRefresh && this.setLoadingMessage()

      return this.entityService.getSubscriberDevicesAndPairingCodes(this.$route.params.id)
          .then(data => {
            pureRefresh && this.emptyMessage()
            !pureRefresh && this.setSuccessMessage()

            this.entity['devices'] = data['devices']
            this.entity['pairing_codes'] = data['pairing_codes']
            this.entity['is_allowed_to_add_device_or_pairing_code'] = data['is_allowed_to_add_device_or_pairing_code']

            this.resetNewDevice()
            this.setNewDeviceOpen(false)
            this.resetNewPairingCode()
            this.setNewPairingCodeOpen(false)
          })
          .catch(function (error) {
            this.setErrorMessage(error['error_message'])
          }.bind(this))
    },

    // DEVICES
    addDevice() {
      let params = this._.pick(this.newDevice, ['name', 'mac_address'])
      params['id_subscriber'] = this.entity.id

      this.deviceService.createEntity(params)
          .then(() => {
            this.refreshDevicesAndPairingCodes()
          })
          .catch((error) => {
            this.$refs['devicesref'].validateRequiredFields(error)
            this.setErrorMessage(this._processDetailErrorMessage(error))
          })
    },
    updateDevice(data) {
      let params = this._.pick(data, ['name', 'id_profile', 'pre_provisioned'])
      params['id_subscriber'] = this.entity.id

      this.deviceService.updateEntity(data['id'], params)
          .then(() => {
            this.refreshDevicesAndPairingCodes()
                .then(() => {
                  this.$refs['devicesref'].closeRows()
                })
          })
          .catch((error) => {
            this.$refs['devicesref'].validateRequiredFields(error)
            this.setErrorMessage(this._processDetailErrorMessage(error))
          })
    },
    deleteDevice(id, showPopup = true) {
      if (showPopup) {
        if (this._.includes(id, ',')) {
          this.showPopup(id, 'delete-multi', 'delete-device-multi')
        } else {
          this.showPopup(id, 'delete', 'delete-device')
        }
      } else {
        this.deviceService.deleteDevice(id)
            .then(() => {
              this.setSuccessMessage()
              this.getEntity()
            })
            .catch(function (error) {
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      }
    },
    onDeleteMessage(id, showPopup = true) {
        if (showPopup) {
            this.showPopup(id, 'delete', 'deleteMessage');
        } else {
            this.messageService.deleteRecipient(id)
                .then(() => {
                    this.setSuccessMessage()
                    this.getEntity()
                })
                .catch(function (error) {
                    this.setErrorMessage(this._processDetailErrorMessage(error))
                }.bind(this))
        }
    },
    onDeleteAdvertisingBanner(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'deleteAdvertisingBanner');
      } else {
        this.advertisingBannerRecipientService.deleteRecipient({id_subscriber: this.entity.id, id_advertising_banner: id, id_selected_operator: this.$_loggedUser_selectedOperatorId})
            .then(() => {
              this.setSuccessMessage()
              this.getEntity()
            })
            .catch(function (error) {
              this.getEntity();
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      }
    },
    onDeletePvr(id, showPopup = true) {
        if (showPopup) {
            this.showPopup(id, 'delete', 'deletePvr');
        } else {
            this.pvrService.deleteEntity(id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
                .then(() => {
                    this.setSuccessMessage()
                    this.getEntity()
                })
                .catch(function (error) {
                  this.getEntity();
                    this.setErrorMessage(this._processDetailErrorMessage(error))
                }.bind(this))
        }
    },
    onDeleteProfile(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'deleteProfile');
      } else {
        this.subscriberProfileService.deleteEntity(id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
            .then(() => {
              this.setSuccessMessage()
              this.getEntity()
            })
            .catch(function (error) {
              this.getEntity();
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      }
    },
    onDeleteFavoriteShow(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'deleteFavoriteShow');
      } else {
        this.favoriteShowService.deleteEntity(id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
            .then(() => {
              this.setSuccessMessage()
              this.getEntity()
            })
            .catch(function (error) {
              this.getEntity();
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      }
    },
    onDeletePeriodicPvr(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'deletePeriodicPvr');
      } else {
        this.periodicPvrService.deleteEntity(id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
            .then(() => {
              this.setSuccessMessage()
              this.getEntity()
            })
            .catch(function (error) {
              this.getEntity();
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      }
    },

    // PAIRING CODES
    addPairingCode() {
      let params = {
        'name': this.newPairingCode['name'],
        'id_subscriber': this.entity.id,
        'id_device': this.newPairingCode['id_device']
      }

      let date = this.$_date_toMysqlFormatFromString(this.newPairingCode['expiration_date'])
      if (date) {
        params['expiration_date'] = date
      }

      this.pairingCodeService.createEntity(params)
          .then(() => {
            this.refreshDevicesAndPairingCodes()
          })
          .catch((error) => {
            this.$refs['devicesref'].validateRequiredFields(error)
            this.setErrorMessage(this._processDetailErrorMessage(error))
          })
    },
    deletePairingCode(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'delete-pairing-code')
      } else {
        this.pairingCodeService.deletePairingCode(id)
            .then(() => {
              this.setSuccessMessage()
              this.getEntity()
            })
            .catch(function (error) {
              this.setErrorMessage(error['error_message'])
            }.bind(this))
      }
    },

    newMessage(){
      this.$router.push({name: 'messageNew', params: {recipient_subscriber_id: this.entity.id}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/SubscriberDetail.vue